import Menu from '@material-ui/core/Menu';
import Radio from '@material-ui/core/Radio';
import {FormattedMessage} from 'react-intl';
import MenuItem from '@material-ui/core/MenuItem';
import DeleteIcon from '@material-ui/icons/Delete';
import React, {useState, useCallback} from 'react';

import './MenuList.scss';

export interface MenuListLocation {
  x: number;
  y: number;
}

export interface MenuListProps {
  open?: boolean;
  items?: string[];
  enableSearch?: boolean;
  location?: MenuListLocation | null;
  onClose?: () => void;
  onDelete?: () => void;
  onSelect?: (value: string) => void;
}

const initialLocation = {
  x: 0,
  y: 0,
};

export function MenuList({
  open = false,
  items = [],
  enableSearch = false,
  location = initialLocation,
  onSelect = () => {},
  onClose = () => {},
  onDelete = () => {},
}: MenuListProps) {
  const [selectedLabel, setSelectedLabel] = useState<string | null>(null);

  const onClick = useCallback(
    (label: string) => {
      setSelectedLabel(label);
      onSelect(label);
    },
    [onSelect]
  );

  return (
    <Menu
      open={open}
      onClose={onClose}
      className="menu-list"
      anchorReference="anchorPosition"
      anchorPosition={{top: location?.y || 0, left: location?.x || 0}}
      onContextMenu={e => e.preventDefault()}
    >
      <MenuItem onClick={onDelete} className="menu-list__item menu-list__item--delete">
        <DeleteIcon className="menu-list__icon" />
        <FormattedMessage
          tagName="span"
          id="dataPrep.segmentation.annotator.menuList.delete"
        />
      </MenuItem>

      {items.map((label, index) => (
        <MenuItem
          key={`label-${index}`}
          className="menu-list__item"
          selected={selectedLabel === label}
          onClick={() => onClick(label)}
        >
          <Radio
            size="small"
            color="primary"
            className="menu-list__radio"
            checked={selectedLabel === label}
          />
          {label}
        </MenuItem>
      ))}
    </Menu>
  );
}

export default MenuList;
